import { myListsDetailsOptionsStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListDetailsPagination";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import { css } from "styled-components";

myListsDetailsOptionsStyles.pagination = {
    cssOverrides: {
        pagination: css`
            @media print {
                display: none;
            }
            background-color: ${COLORS.background.base};
            height: 30px;
            text-transform: uppercase;
            font-size: ${TYPOGRAPHY.size.smallest};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 35px;
                    `,
                    css`
                        margin-bottom: 35px;
                    `,
                    css`
                        margin-bottom: 35px;
                    `,
                    null,
                    null,
                ])}
        `,
        perPageSelect: css`
            label {
                padding-top: 0px;
                text-overflow: unset;
                overflow: unset;
                width: 100%;
            }
            > div {
                width: 255px;
                > div {
                    select {
                        height: 100%;
                        padding-right: 0px !important; 
                    }
                    span {
                        top: -5px !important;
                    }
                }
            }
        `,
        currentButton: css`
            min-height: 30px;
        `,
    },
}